var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1492 16.4167C10.8295 16.8163 10.2094 16.7746 9.94614 16.3358L7.68745 12.5713C7.27329 11.881 6.52734 11.4587 5.72236 11.4587H3.54102V3.54199H13.7264C14.1961 3.54199 14.6077 3.85639 14.7313 4.30958L16.3222 10.1429C16.5029 10.8056 16.0041 11.4587 15.3173 11.4587H11.5047C10.7511 11.4587 10.2106 12.1851 10.4271 12.9069L11.2792 15.747C11.3485 15.978 11.2999 16.2283 11.1492 16.4167ZM12.1253 17.1975C11.2615 18.2773 9.58573 18.1646 8.87428 16.9789L6.61559 13.2144C6.42733 12.9006 6.08826 12.7087 5.72236 12.7087H3.41602C2.7947 12.7087 2.29102 12.205 2.29102 11.5837V3.41699C2.29102 2.79567 2.7947 2.29199 3.41602 2.29199H13.7264C14.7598 2.29199 15.6654 2.98367 15.9373 3.98068L17.5282 9.81402C17.9258 11.2718 16.8283 12.7087 15.3173 12.7087H11.6727L12.4764 15.3878C12.6637 16.0121 12.5325 16.6886 12.1253 17.1975Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83268 12.7087C5.4875 12.7087 5.20768 12.4288 5.20768 12.0837V2.91699C5.20768 2.57181 5.4875 2.29199 5.83268 2.29199C6.17786 2.29199 6.45768 2.57181 6.45768 2.91699V12.0837C6.45768 12.4288 6.17786 12.7087 5.83268 12.7087Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.2d339c24b7d507ea037bd8ee5b0f6196.svg";
export { ForwardRef as ReactComponent };